module.exports = __webpack_public_path__ + "static/media/gallery-next.8ada7682.svg";